import { z } from "zod"
import type { SortConfig } from "@/components/ui/data-table"
import { DEFAULT_PAGE_SIZE } from "@/lib/constants"

export const stringList = z.array(z.string()).default([]).catch([])

export function paginatedSearch(defaultSort: SortConfig) {
	return {
		page: z.number().int().min(0).default(0).catch(0),
		pageSize: z
			.number()
			.int()
			.positive()
			.default(DEFAULT_PAGE_SIZE)
			.catch(DEFAULT_PAGE_SIZE),
		sort: z
			.object({ columnId: z.string(), direction: z.enum(["asc", "desc"]) })
			.default(defaultSort)
			.catch(defaultSort),
	}
}
